import { createStore } from 'vuex';
import { EmployeeService, type Employee } from '@/services/EmployeeService';

export default createStore({
    state: {
        employees: [] as Employee[],
    },
    mutations: {
        setEmployees(state, employees: Employee[]) {
            state.employees = employees;
        },
        addEmployee(state, employee: Employee) {
            state.employees.push(employee);
        },
        updateEmployee(state, updatedEmployee: Employee) {
            const index = state.employees.findIndex(e => e.id === updatedEmployee.id);
            if (index !== -1) {
                state.employees.splice(index, 1, updatedEmployee);
            }
        },
    },
    actions: {
        async fetchEmployees({ commit }) {
            const employees = await EmployeeService.getEmployees();
            commit('setEmployees', employees);
        },
        async addEmployee({ commit }, employee: Employee) {
            const newEmployee = await EmployeeService.addEmployee(employee);
            commit('addEmployee', newEmployee);
        },
        async updateEmployee({ commit }, employee: Employee) {
            const updatedEmployee = await EmployeeService.updateEmployee(employee);
            commit('updateEmployee', updatedEmployee);
        },
    },
    modules: {},
});
